import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { NameValuePair } from '../models/NameValuePair.models';
import { TranslationConstants } from '../constants/translations.constats';
import { MENIES_TRANSLATIONS } from '../../../app-module/menu-nav-bar/menies.constant';
import { UrlPrefix } from "../constants/url-prefix.constants";
import { SystemDictionaries } from '../models/SystemDictionaries';

@Injectable()
export class TranslationService {
    constructor(private http: HttpClient) { }

    public translateModule(keys: Array<string>): Promise<Array<NameValuePair>> {
        return this.http.post<Array<NameValuePair>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/translations/translate`, JSON.stringify(keys)).toPromise();
    }

    /**
 * @param key  The key
 * @return translated value or key if does not exists
 */
    public translate(key: string): string {
        const translations: Array<NameValuePair> = JSON.parse(localStorage.getItem(TranslationConstants.TRANSLATIONS)) || [];
        const translation = translations.find(x => x.name === key);
        if (translation) {
            return translation.value;
        } else {
            return key;
        }
    }

    public translateMenu(): Observable<Array<NameValuePair>> {
        return this.http.post<Array<NameValuePair>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/translations/translate`, JSON.stringify(MENIES_TRANSLATIONS));
    }
    
    public getSystemDictionaries(): Observable<SystemDictionaries>{
        return this.http.get<SystemDictionaries>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/tenant/systemDictionaries`)
    }
}
